import React, { useEffect } from "react";

import { Terminal } from "./Terminal";

import "@code-hike/mini-frame/dist/index.css";
import "@code-hike/mini-terminal/dist/index.css";

export function Term({ yarnCommands }) {
  const [count, setCount] = React.useState(0);

  const [progress, setProgress] = React.useState(0);

  let slide = 0;

  useEffect(() => {
    setInterval(() => {
      setProgress(slide % yarnCommands.split("|").length);
      slide++;
    }, 2000);
  }, []);
  return (
    <div className="App">
      <Terminal snippets={yarnCommands.split("|")} index={progress} />
    </div>
  );
}
